import React from "react";
import PropTypes from "prop-types";

export default function Info({ className, color }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.0009"
        cy="10"
        r="7.69231"
        stroke={color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M10 14.1958V9.65039"
        stroke={color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M10 6.50348V6.15383"
        stroke={color || "white"}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

Info.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Info.defaultProps = {
  className: "",
  color: "",
};
